// Enhanced Services Data Structure
export const servicesData = {
  vastu: {
    id: 'vastu',
    title: 'Vastu Shastra',
    icon: 'fas fa-home',
    description: 'Ancient science of architecture and space harmony',
    categories: {
      residential: {
        id: 'residential',
        title: 'Residential Vastu',
        description: 'Harmonize your living spaces',
        icon: 'fas fa-house-user',
        pricing: { india: 15000, abroad: 1500, startingFrom: true },
        subServices: {
          plot: {
            id: 'plot',
            title: 'Plot Analysis',
            description: 'Land selection and plot evaluation'
          },
          home: {
            id: 'home',
            title: 'Home Vastu',
            description: 'Complete home Vastu consultation'
          },
          apartment: {
            id: 'apartment',
            title: 'Apartment Vastu',
            description: 'Apartment layout optimization'
          }
        }
      },
      commercial: {
        id: 'commercial',
        title: 'Commercial Vastu',
        description: 'Business prosperity through Vastu',
        icon: 'fas fa-building',
        pricing: { india: 25000, abroad: 2100, startingFrom: true },
        subServices: {
          office: {
            id: 'office',
            title: 'Office Vastu',
            description: 'Workplace productivity enhancement'
          },
          shop: {
            id: 'shop',
            title: 'Shop & Retail',
            description: 'Retail space optimization'
          },
          restaurant: {
            id: 'restaurant',
            title: 'Restaurant & Hospitality',
            description: 'Food & hospitality business optimization'
          }
        }
      },
      industrial: {
        id: 'industrial',
        title: 'Industrial Vastu',
        description: 'Large-scale industrial facility optimization',
        icon: 'fas fa-industry',
        pricing: { india: 51000, abroad: 5000, startingFrom: true },
        subServices: {
          sme: {
            id: 'sme-industrial',
            title: 'SME Industrial Vastu',
            description: 'Small & Medium Enterprise industrial solutions'
          },
          largeCorporate: {
            id: 'large-corporate-industrial',
            title: 'Large Corporate Industrial',
            description: 'Enterprise-level industrial Vastu consultation'
          },
          manufacturing: {
            id: 'manufacturing',
            title: 'Manufacturing Units',
            description: 'Production facility layout optimization'
          },
          warehouse: {
            id: 'warehouse',
            title: 'Warehouse & Storage',
            description: 'Storage facility planning'
          },
          powerPlant: {
            id: 'power-plant',
            title: 'Power Plants',
            description: 'Energy facility Vastu consultation'
          }
        }
      },
      rangVastu: {
        id: 'rang-vastu',
        title: 'Rang Vastu',
        description: 'Color-based Vastu consultation for harmony',
        icon: 'fas fa-palette',
        pricing: { india: 15000, abroad: 1500, startingFrom: true }
      },
      architecturePlanning: {
        id: 'architecture-planning',
        title: 'Architecture Planning Analysis',
        description: 'Complete architectural design and planning consultation',
        icon: 'fas fa-drafting-compass',
        pricing: { india: 25000, abroad: 2100, startingFrom: true }
      },
      vastuVisit: {
        id: 'vastu-visit',
        title: 'Vastu Site Visit',
        description: 'On-site Vastu consultation and analysis',
        icon: 'fas fa-map-marker-alt',
        pricingOptions: {
          withPackage: {
            title: 'Complete Package',
            price: { india: 51000, abroad: 5000 },
            description: 'All-inclusive site visit with complete analysis'
          },
          withoutPackage: {
            title: 'Individual Services',
            services: {
              firstVisit: {
                title: 'First Visit',
                price: { india: 15000, abroad: 1500 }
              },
              followupVisit: {
                title: 'Follow-up Visit (SOS)',
                price: { india: 11000, abroad: 1100 }
              },
              architectMeeting: {
                title: 'Architect Meeting',
                price: { india: 11000, abroad: 1100 }
              },
              planFinal: {
                title: 'Plan Finalization',
                price: { india: 25000, abroad: 2500 }
              }
            }
          }
        }
      }
    }
  },
  numerology: {
    id: 'numerology',
    title: 'Numerology',
    icon: 'fas fa-calculator',
    description: 'Unlock the power of numbers in your life',
    categories: {
      phoneNumerology: {
        id: 'phone-numerology',
        title: 'Phone Numerology',
        description: 'Lucky mobile number analysis and selection',
        icon: 'fas fa-mobile-alt',
        pricing: { india: 7500, abroad: 500, startingFrom: true }
      },
      birthDateNumerology: {
        id: 'birth-date-numerology',
        title: 'Birth Date Numerology',
        description: 'Life path analysis through birth date',
        icon: 'fas fa-calendar-day',
        pricing: { india: 7500, abroad: 500, startingFrom: true }
      },
      carNumberNumerology: {
        id: 'car-number-numerology',
        title: 'Car Number Numerology',
        description: 'Vehicle number selection for prosperity',
        icon: 'fas fa-car',
        pricing: { india: 7500, abroad: 500, startingFrom: true }
      },
      nameNumerology: {
        id: 'name-numerology',
        title: 'Name Numerology',
        description: 'Name correction and analysis',
        icon: 'fas fa-signature',
        pricing: { india: 7500, abroad: 500, startingFrom: true }
      }
    }
  },
  astrology: {
    id: 'astrology',
    title: 'Vedic Astrology',
    icon: 'fas fa-star',
    description: 'Ancient wisdom of planetary influences',
    categories: {
      horoscopeAnalysis: {
        id: 'horoscope-analysis',
        title: 'Horoscope Analysis',
        description: 'Complete birth chart reading and predictions',
        icon: 'fas fa-chart-pie',
        pricing: { india: 2500, abroad: 30, startingFrom: true }
      },
      matchMaking: {
        id: 'match-making',
        title: 'Match Making',
        description: 'Marriage compatibility analysis',
        icon: 'fas fa-heart',
        pricing: { india: 3000, abroad: 40, startingFrom: true }
      },
      horoscopeMaking: {
        id: 'horoscope-making',
        title: 'Horoscope Making',
        description: 'Complete birth chart creation and analysis',
        icon: 'fas fa-scroll',
        pricing: { india: 5500, abroad: 50, startingFrom: true }
      },
      financialAstrology: {
        id: 'financial-astrology',
        title: 'Financial Astrology',
        description: 'Wealth and business predictions',
        icon: 'fas fa-coins',
        pricing: { india: 7500, abroad: 100, startingFrom: true }
      },
      children: {
        id: 'children',
        title: 'Children Astrology',
        description: 'Child birth timing and naming',
        icon: 'fas fa-baby',
        pricing: { india: 5100, abroad: 75, startingFrom: true }
      },
      marriage: {
        id: 'marriage',
        title: 'Marriage Astrology',
        description: 'Marriage timing and compatibility',
        icon: 'fas fa-ring',
        pricing: { india: 7500, abroad: 100, startingFrom: true }
      },
      videshYog: {
        id: 'videsh-yog',
        title: 'Videsh Yog (Foreign)',
        description: 'Foreign travel and settlement predictions',
        icon: 'fas fa-globe-americas',
        pricing: { india: 7500, abroad: 100, startingFrom: true }
      }
    }
  },
  pooja: {
    id: 'pooja',
    title: 'Pooja Services',
    icon: 'fas fa-om',
    description: 'Sacred rituals and spiritual ceremonies',
    categories: {
      yantraPooja: {
        id: 'yantra-pooja',
        title: 'Yantra Pooja',
        description: 'Sacred geometric ritual ceremonies',
        icon: 'fas fa-star-of-david',
        pricing: { india: 5100, abroad: 75, startingFrom: true }
      },
      poojaVidhi: {
        id: 'pooja-vidhi',
        title: 'Pooja Vidhi',
        description: 'Traditional ritual procedures and guidance',
        icon: 'fas fa-hands-praying',
        pricing: { india: 2500, abroad: 50, startingFrom: true }
      },
      ganeshPooja: {
        id: 'ganesh-pooja',
        title: 'Ganesh Pooja',
        description: 'Lord Ganesha worship ceremonies',
        icon: 'fas fa-elephant',
        pricing: { india: 5100, abroad: 75, startingFrom: true }
      },
      navgrahaPooja: {
        id: 'navgraha-pooja',
        title: 'Navgraha Pooja',
        description: 'Nine planets worship ritual',
        icon: 'fas fa-sun',
        pricing: { india: 7500, abroad: 100, startingFrom: true }
      }
    }
  },
  others: {
    id: 'others',
    title: 'Others',
    icon: 'fas fa-ellipsis-h',
    description: 'Additional spiritual and analytical services',
    categories: {
      gemstoneConsultation: {
        id: 'gemstone-consultation',
        title: 'Gemstone Consultation',
        description: 'Precious stone recommendation and benefits',
        icon: 'fas fa-diamond',
        pricing: { india: 2500, abroad: 50, startingFrom: true }
      },
      spiritualRemedies: {
        id: 'spiritual-remedies',
        title: 'Spiritual Remedies',
        description: 'Customized spiritual solutions and remedies',
        icon: 'fas fa-leaf',
        pricing: { india: 2500, abroad: 50, startingFrom: true }
      },
      muhuratSelection: {
        id: 'muhurat-selection',
        title: 'Muhurat Selection',
        description: 'Auspicious timing selection for important events',
        icon: 'fas fa-clock',
        pricing: { india: 1100, abroad: 30, startingFrom: true }
      },
      logoAnalysis: {
        id: 'logo-analysis',
        title: 'Logo Analysis',
        description: 'Business logo design and analysis for success',
        icon: 'fas fa-palette',
        pricing: { india: 2000, abroad: 30, startingFrom: true }
      }
    }
  },
  consultation: {
    id: 'consultation',
    title: 'Consultation Services',
    icon: 'fas fa-user-tie',
    description: 'Personalized guidance and spiritual consultation',
    categories: {
      crystalConsultation: {
        id: 'crystal-consultation',
        title: 'Crystal Consultation',
        description: 'Healing crystal selection and guidance',
        icon: 'fas fa-gem',
        pricing: { india: 2500, abroad: 100, startingFrom: true }
      },
      rudrakshConsultation: {
        id: 'rudraksh-consultation',
        title: 'Rudraksh Consultation',
        description: 'Sacred bead selection and benefits',
        icon: 'fas fa-circle-notch',
        pricing: { india: 2500, abroad: 100, startingFrom: true }
      },
      siteVisitConsultation: {
        id: 'site-visit-consultation',
        title: 'Site Visit Consultation',
        description: 'On-location Vastu and energy assessment',
        icon: 'fas fa-map-marker-alt',
        pricing: { india: 7500, abroad: 500, startingFrom: true }
      },
      gemstoneConsultation: {
        id: 'gemstone-consultation',
        title: 'Gemstone Consultation',
        description: 'Precious stone recommendation and benefits',
        icon: 'fas fa-diamond',
        pricing: { india: 5100, abroad: 150, startingFrom: true }
      }
    }
  }
};